import { useState } from "react";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import {
  getAlertActivationSettingsAction,
  deleteAlertSettingsAction,
  duplicateAlertSettingsAction
} from "../actions";
import { getLocalizedString } from "@icarius-localization/strings";

const useABM = () => {

  const dispatch = useDispatch();

  const [duplicateDialogIsOpen, setDuplicateDialogIsOpen] = useState(false);
  const [deleteDialogIsOpen, setDeleteDialogIsOpen] = useState(false);
  const [createEditDialogIsOpen, setCreateEditDialogIsOpen] = useState(false);
  const [activationIsOpen, setActivationIsOpen] = useState(false);
  const [codeToDelete, setCodeToDelete] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleOpenCreateDialog = () => {
    setCreateEditDialogIsOpen(true);
  }

  const handleOpenActivationPage = (code) => {
    dispatch(getAlertActivationSettingsAction(code))
    .then(() => {
      setActivationIsOpen(true);
    })
  }

  const handleCloseActivationPage = () => {
    setActivationIsOpen(false);
  }

  const handleOpenDuplicateDialog = (gridRef) => {
    //Obtener los seleccionados y armar array de files
    let selectedRows = gridRef.api.getSelectedRows();

    // Si no hay seleccionado, pido seleccionar
    if (selectedRows.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectSingleItem"), severity: "warning" }));
      return;
    }

    setDuplicateDialogIsOpen(true);
    setSelectedItem(selectedRows[0]);
  };

  const handleCloseDuplicateDialog = () => {
    setDuplicateDialogIsOpen(false);
    setSelectedItem(null);
  }

  const handleOpenEditDialog = (gridRef) => {
    //Obtener los seleccionados y armar array de files
    let selectedRows = gridRef.api.getSelectedRows();

    // Si no hay seleccionado, pido seleccionar
    if (selectedRows.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectSingleItem"), severity: "warning" }));
      return;
    }

    setCreateEditDialogIsOpen(true);
    setSelectedItem(selectedRows[0]);
  };

  const handleCloseEditDialog = () => {
    setCreateEditDialogIsOpen(false);
    setSelectedItem(null);
  }

  const handleOpenDeleteDialog = (gridRef) => {
    //Obtener los seleccionados y armar array de files
    let selectedRows = gridRef.api.getSelectedRows();

    // Si no hay seleccionado, pido seleccionar
    if (selectedRows.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectSingleItem"), severity: "warning" }));
      return;
    }

    setDeleteDialogIsOpen(true);
    setCodeToDelete(selectedRows.map(item => item[getLocalizedString("alertOrNoticeType")])[0]);
  }

  const handleCloseDeleteDialog = () => {
    setDeleteDialogIsOpen(false);
    setCodeToDelete(null);
  }

  const handleDelete = () => {
    dispatch(deleteAlertSettingsAction({ 'Tipo de Alerta o Aviso': codeToDelete }))
      .then(() => {
        handleCloseDeleteDialog();
      })
  }

  const handleDuplicate = (data) => {
    dispatch(duplicateAlertSettingsAction(data))
      .then(() => {
        handleCloseDuplicateDialog();
      })
  }

  return {
    deleteDialogIsOpen,
    createEditDialogIsOpen,
    duplicateDialogIsOpen,
    activationIsOpen,
    selectedItem,
    handleOpenCreateDialog,
    handleOpenEditDialog,
    handleCloseEditDialog,
    handleOpenActivationPage,
    handleCloseActivationPage,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    handleOpenDuplicateDialog,
    handleCloseDuplicateDialog,
    handleDelete,
    handleDuplicate
  }
}

export default useABM;
